import {get} from 'lodash'
import {getBuildNumber} from "../actions/address";
import * as modal from "../reducers/modalReducer";
const SUCCESS = "SUCCESS";
export const BUILD_NUMBER = "BUILD_NUMBER";
export const BUILD_NUMBER_REFRESH_TIME = "BUILD_NUMBER_REFRESH_TIME";
const successfulResponse = (response) => (!!response && response.resultCode === SUCCESS);
const MINUTE_CONVERSION = 60 * 1000;
const REFRESH_MESSAGE = 'We\'re updating Treez to arm you with the latest and greatest, this page will automatically refresh.';
const GENERIC_MODAL = "GENERIC";
const DURATION_AFTER_MODAL_TO_REFRESH = 3000;

export const setupBuildNumberTimer = (store) => {

  return getBuildNumber().then(res => {
    let response = get(res, `data`);

    if (successfulResponse(response)) {
      let dataBaseRefreshTime = get(res, `data.data.${BUILD_NUMBER_REFRESH_TIME}`) * MINUTE_CONVERSION;
      setInterval(()=> {
        compareBuildVersions(store)
      }, dataBaseRefreshTime)

    }
  });
};

let localBuildNumber = null;

export const compareBuildVersions = async (store) => {

  return getBuildNumber().then(res => {

    let response = get(res, `data`);
    if (successfulResponse(response)) {
      const dataBaseBuildNumber = get(res, `data.data.${BUILD_NUMBER}`);

      if (localBuildNumber) {
        if (localBuildNumber !== dataBaseBuildNumber) {

          store.dispatch(modal.openModal({
            modalType: GENERIC_MODAL,
            modalProps: {
              text: REFRESH_MESSAGE,
              stay: true,
            }
          }))

          setTimeout(() => {
            window.location.reload(true)
          }, DURATION_AFTER_MODAL_TO_REFRESH)

        }
      } else {
        localBuildNumber = dataBaseBuildNumber;
      }
    }
  });
}




// WEBPACK FOOTER //
// ./src/helpers/build_number_timer.js